import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deputation-rec-form',
  templateUrl: './deputation-rec-form.component.html',
  styleUrls: ['./deputation-rec-form.component.css']
})
export class DeputationRecFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/deputaion/deputaion-rec/deputation-rec-form/deputation-rec-form.component.ts